import type { Elemental, ElementalType } from '~~/src/types/elemental'

interface ElementalFormContextType {
  formId: Ref<string>
  elemental: Ref<Elemental | null | undefined>
  elementalType: ComputedRef<ElementalType | null>
  disabled?: Ref<boolean>
  isSidebarView?: Ref<boolean>
  isLoading?: Ref<boolean>
  isSaving?: Ref<boolean>
  autosave?: ComputedRef<boolean>
  submitError?: Ref<boolean>
  dispatchChange: (by?: string) => void
}

export const ElementalFormContextKey = Symbol('ElementalFormContext') as InjectionKey<ElementalFormContextType>

export const useElementalForm = (): ElementalFormContextType => {
  const context = inject(ElementalFormContextKey)
  if (!context)
    throw new Error('useElementalFormContext must be used within a ElementalFormProvider')

  return context
}
